<script>
import swal from 'sweetalert2';
import { DataTable } from 'simple-datatables';

export default {
    data() {
        return {
            action: "",
            property: null,
        };
    },

    methods: {
        changed() {
            this.action = route('employee.leases.add', {
                property: this.property,
            });
        },

        deleteLease(lease) {
            swal({
                title: 'Are you sure?',
                text: "You won't be able to undo this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#dd3333',
                confirmButtonText: 'Yes, delete it!',
            })
                .then(reason => {
                    // Dismissed/closed
                    if (reason.hasOwnProperty('dismiss')) {
                        return;
                    }

                    this.$axios
                        .delete(
                            route('employee.leases.delete', {
                                lease: lease,
                            }),
                        )
                        .then(response => {
                            if (!response.data.status) {
                                swal({
                                    title: 'Error',
                                    text: response.data.error,
                                    type: 'error',
                                }).catch(swal.noop);
                            } else {
                                window.location.reload();
                            }
                        });
                })
                .catch(swal.noop);
        },
    },

    mounted() {
        const table = document.querySelector('table.table-datatables');
        const datatable = new DataTable(table, {
            'perPage': 25,
            'perPageSelect': false,
        });

        const handlers = () => {
            table.querySelectorAll('a[data-delete]').forEach(a => {
                a.addEventListener('click', () => {
                    const id = a.getAttribute('data-delete');
                    this.deleteLease(id);
                });
            });
        };

        datatable.on('datatable.init', handlers);
        datatable.on('datatable.update', handlers)
    },
};
</script>
